import { REASON_SECTION } from '../../../data/site';

export function ReasonSection() {
  return (
    <section className="reason">
      <div className="reason-bg-wrap">
        {/* <img src="https://hellogwiji.com/images/maps.png" loading="lazy" alt="Reason Image" className="reason-bg" /> */}
      </div>
      <div className="reason-center-wrap">
        <div className="reason-wrap">
          <div className="section-header-wrap">
            <div className="section-header-content">
              <div className="section-header-text-wrap">
                <div className="heading-wrap">
                  <h3 className="text-center text-white">
                    {REASON_SECTION.title}
                  </h3>
                </div>
                <div className="subtitle-wrap">
                  <div className="paragraph-02 text-center text-white">
                    {REASON_SECTION.subtitle}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="reason-content-wrap">
            <div data-w-id="18254ee0-776b-224f-fc83-c9663461eb50" style={{WebkitTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', MozTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', msTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', transform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', opacity: '0', filter: 'blur(5px)'}} className="reason-card">
              <div className="reason-image-wrap">
                <img src="https://images.unsplash.com/photo-1524281423221-234569bc0438?q=80&w=3264&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" loading="lazy" alt="Reason Image" className="fit-cover reason-image" />
                <div className="reason-image-cover">
                </div>
              </div>
              <div className="reason-card-content">
                <div className="reason-button-wrap">
                  <a href="/waitlist" className="text-style-h4 text-white w-inline-block">
                    {REASON_SECTION.cta}
                  </a>
                </div>
                <div className="reason-bottom-content">
                  <div className="reason-text-wrap">
                    <div className="paragraph-01 text-white">
                      {REASON_SECTION.overlayText}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
